<template>
  <v-menu
    v-model="menuAdd"
    bottom
    right
    offset-y
    origin="top right"
    :nudge-width="263"
    :close-on-content-click="false"
    transition="scale-transition"
    content-class="tile tile__filters overflow-hidden py-3"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on" exact>
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <div class="filters__container">
      <v-list-group
        no-action
        sub-group
        v-for="(f, i) in filterTypes"
        :key="i"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>{{ f.type }}</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item class="pa-0 ma-0 d-flex justify-start">
          <v-radio-group
            v-model="f.selected"
            class="px-10"
          >
            <v-radio
              v-for="(option, i) in f.options"
              :key="i"
              :label="option"
              :value="option"
              @click.stop="uncheck(f, option)"
              @change="inputChange = true"
            ></v-radio>
          </v-radio-group>
        </v-list-item>
      </v-list-group>
    </div>
  </v-menu>    
</template>

<script>
// import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      inputChange: false,
      menuAdd: false,
      seccionesName: [],
      institucionesName: [],
      items: [
        { nombre: 'Orden alfabético' },
        { nombre: 'Pagos pendientes' },
        { nombre: 'Por sección' },
      ],
      filterTypes: [
        { id: 1, type: 'Orden alfabético', state: null, options: ['Banqueo', 'Flashcards'], selected: null },
        { id: 2, type: 'Ascendente', state: null, options: this.institucionesName, selected: null },
        { id: 3, type: 'Descendente', state: null, options: this.seccionesName, selected: null }
      ],
      previouslyFilter: null
    }
  },
  computed: {
  },
  methods: {
  },
  watch: {
    // filterTypesSelected: {
    //   deep: true,
    //   handler () {
    //     this.$emit('applyFilter', this.filterTypes)
    //     // localStorage.setItem('filters', JSON.stringify(this.filterTypes))
    //     this.inputChange = false
    //   }
    // }
  },
  async created () {
  }
}
</script>

<style lang="scss" scoped>
.v-menu__content.tile {
  &__filters {
    background: #FFF !important;
    box-shadow: none !important;
    border: 1px solid #CED4DA;
  }
}
.filters {
  &__title {
    font: normal normal 300 14px/21px Poppins;
    font-size: 14px;
    letter-spacing: 0px;
    color: #54667A;
  }
  &__container {
      max-height: calc(100% - 150px);
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      -ms-overflow-style: none;
      scrollbar-width: none !important;
  
      &::-webkit-scrollbar {
        display: none;
      }
    }
}
</style>
